import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';
import moment from 'moment';
import { downloadUrlFile } from '../util';

const TableContent = ({
    renderData: {
        dataList,
        pageNum,
        pageSize,
        resultTotal
    },
    paginationChange,
    history,
    scrollY,
    tableHandle
}) => {

    const tableOperate = (text, item) => {
        if (item.type == 'SMS') {
            return <div className={styles.action}>
                <div className={styles.item} onClick={() => tableHandle('note', item)}>查看</div>
            </div>;
        } else {
            return <div className={styles.action}>
                <div className={styles.item} onClick={() => tableHandle('play', item)}>播放</div>
                <div className={styles.item} onClick={() => downloadUrlFile(item.recordUrl)}>下载</div>
            </div>;
        }
    };

    const columns = [
        {
            title: '配送单号',
            dataIndex: 'deliveryIdStr',
            key: 'deliveryIdStr',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltipClick(text, () => {
                history.push({
                    pathname: `/home/order/distributionorder/orderdetail/${item.deliveryId}`,
                });
            }, 'left')
        },
        {
            title: '通话ID',
            dataIndex: 'recordId',
            key: 'recordId',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '主叫号码',
            dataIndex: 'callerNo',
            key: 'callerNo',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '被叫号码',
            dataIndex: 'peerNo',
            key: 'peerNo',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '虚拟号',
            dataIndex: 'secretNo',
            key: 'secretNo',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '通信类型',
            dataIndex: 'typeDesc',
            key: 'typeDesc',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '通话开始时间',
            dataIndex: 'startTime',
            key: 'startTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: text => tooltip(text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '')
        },
        {
            title: '通话结束时间',
            dataIndex: 'releaseTime',
            key: 'releaseTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: text => tooltip(text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '')
        },
        {
            title: '通话时长',
            dataIndex: 'formatStrCallTime',
            key: 'formatStrCallTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: 320,
            fixed: 'right',
            onCell: tooltipStyle,
            render: tableOperate
        }
    ];

    return <div className={styles.tableContainer} style={{ height: '100%' }}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={item => item.id}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ x: 'max-content', y: scrollY }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={paginationChange}
        />
    </div>;
};

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    paginationChange: PropTypes.func.isRequired, // 分页操作
    scrollY: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tableHandle: PropTypes.func
};

export default TableContent;

